import React, { useMemo } from "react";
// Bootstrap
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { FormatCurrency2Dec, FormatInt } from "../../utils/FormatData";
import GenericWidget from "../../components/widgets/GenericWidget";
import CustomerBarGraph from "./CustomerBarGraph";
import * as FiIcons from "react-icons/fi";
import { httpClient } from "../../utils/HttpClient";
import { useAuth } from "../../Context/AuthContext";
import moment from "moment";
import { useQuery } from "@tanstack/react-query";
import { WarningMessage } from "../../utils/toastify";
class Graph {
  constructor(data) {
    this.data = data.filter((item) => item.i_total > 100);
  }

  getCategories() {
    const customers = [...new Set(this.data.map((item) => item.vc_customer))];
    return customers;
  }

  getData() {
    const customers = this.getCategories();

    const dataToGraph1 = [];
    const dataToGraph2 = [];

    customers.map((vc_customer) => {
      let subtotal = this.data
        .filter((item) => item.vc_customer === vc_customer)
        .reduce((total, row) => {
          return parseInt(row.i_total) + parseInt(total);
        }, 0);

      let amount = this.data
        .filter((item) => item.vc_customer === vc_customer)
        .reduce((total, row) => {
          return parseInt(row.n_amount) + parseInt(total);
        }, 0);

      dataToGraph1.push(subtotal);
      dataToGraph2.push(amount);
    });

    return [dataToGraph1, dataToGraph2];
  }
}

const AdminDashboard = () => {
  const Auth = useAuth();
  const { token } = Auth.getSessionData();

  const {
    isPending: isPendingReport,
    isRefetching: isRefetchingReport,
    data: reportData,
    isError: isErrorReport,
  } = useQuery({
    queryKey: ["getSummaryData"],
    queryFn: async () => {
      const date = new Date();
      const from = new Date(date.getFullYear(), date.getMonth(), 1);
      const to = new Date();
      try {
        const response = await httpClient(
          "POST",
          `${ApiEndpoint}administration/report/summary`,
          {
            from: moment(from).format("YYYY/MM/DD"),
            to: moment(to).format("YYYY/MM/DD"),
          },
          token,
        );

        return response.data;
      } catch (error) {
        WarningMessage("Ha ocurrido un error, intente recargando nuevamente.");
      }
    },
    refetchOnWindowFocus: false,
    initialData: [],
  });

  const {
    isPending: isPendingBar,
    isRefetching: isRefetchingBar,
    data: reportBar,
    isError: isErrorBar,
  } = useQuery({
    queryKey: ["getReportBarData"],
    queryFn: async () => {
      const date = new Date();

      const from = new Date(date.getFullYear(), date.getMonth(), 1);
      const to = new Date();

      const response = await httpClient(
        "POST",
        ApiEndpoint + "administration/report/customersummary",
        {
          from: moment(from).format("YYYY/MM/DD"),
          to: moment(to).format("YYYY/MM/DD"),
        },
        token,
      );

      return response.data;
    },
    refetchOnWindowFocus: false,
    initialData: [],
  });

  const { dataCategories, dataReport1 } = useMemo(() => {
    const Resolver = new Graph(reportBar);

    const dataCategories = Resolver.getCategories();
    const dataReport1 = Resolver.getData();

    return {
      dataCategories,
      dataReport1,
    };
  }, [reportBar]);

  const WIDGETS_ARRAY = [
    {
      key: "Widget1",
      title: "Ingreso Actual",
      legend: "Mes Actual",
      quantity: FormatCurrency2Dec(reportData?.n_amount ?? 0),
      icon: <FiIcons.FiDollarSign />,
    },
    {
      key: "Widget2",
      title: "Mensajes Enviados",
      legend: "Mes Actual",
      quantity: FormatInt(reportData?.i_total ?? 0),
      icon: <FiIcons.FiMail />,
    },
    {
      key: "Widget3",
      title: "Mensajes Por Enviar",
      legend: "Mes Actual",
      quantity: reportData?.i_programed ?? 0,
      icon: <FiIcons.FiSend />,
    },
  ];
  return (
    <>
      {reportData && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {WIDGETS_ARRAY.map((item) => (
              <GenericWidget
                key={item.key}
                className={item.key}
                title={item.title}
                legend={item.legend}
                quantity={item.quantity}
                icon={item.icon}
                loading={isPendingReport || isRefetchingReport || isErrorReport}
              />
            ))}
          </div>
          <div className="py-4">
            <CustomerBarGraph
              dataCategories={dataCategories}
              dataReport={dataReport1}
              loading={isPendingBar || isRefetchingBar || isErrorBar}
            />
          </div>
        </>
      )}
    </>
  );
};

export default AdminDashboard;
